package com.macrofocus.eflux.network.logical

class LogicalBranchId(val from: LogicalBusId, val to: LogicalBusId, val circuit: String?) {
    val name = if(circuit != null) {
        from.name + "-" + to.name + "-" + circuit
    } else {
        from.name + "-" + to.name
    }

    fun isSameDirection(other: LogicalBranchId): Boolean {
        return from == other.from && to == other.to
    }

    override fun equals(other: Any?): Boolean {
        if (this === other) return true
        if (other !is LogicalBranchId) return false

        if(from == other.from && to == other.to && circuit == other.circuit) return true
        if(from == other.to && to == other.from && circuit == other.circuit) return true

        return false
    }

    override fun hashCode(): Int {
        var result = from.hashCode() + to.hashCode()
        result = 31 * result + (circuit?.hashCode() ?: 0)
        return result
    }

    override fun toString(): String = name
}

inline fun logicalBranchIdOf(from: LogicalBusId, to: LogicalBusId, circuit: String?) : LogicalBranchId = LogicalBranchId(from, to, circuit)
inline fun logicalBranchIdOf(name: String) : LogicalBranchId = run {
    val ids = name.split("-")
    LogicalBranchId(logicalBusIdOf(ids[0]), logicalBusIdOf(ids[1]), if(ids.size > 2) ids[2] else null)
}